import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { accessTokenService } from "../../services/access-token-service";

interface AuthTokenInitializerProps {
  children: React.ReactNode;
}

export function AuthTokenInitializer({ children }: AuthTokenInitializerProps) {
  const { instance } = useMsal();

  useEffect(() => {
    accessTokenService.initialize(instance);
  }, [instance]);

  return <>{children}</>;
}
